export const ProfileDescriptionValidation = [
    { required: true, message: 'Profile Description is required' },
    { max: 50, message: 'Profile Description must have maximum of 30 letters' },
    { min: 2, message: 'Profile Description must have minimum of 2 letters' },
];

export const PriceValidation = [
    { required: true, message: 'Price is required' },
];

export const ExperienceValidation = [
    { required: true, message: 'Experience is required' },
];